const calculateReceiveAmount = (amount) => amount * 0.15 + (amount * 0.15) * 0.21;

export { calculateReceiveAmount }